import React, {createContext, useContext, useState} from 'react';

// 1. Context 생성
const RightSideBarContext = createContext();

// 2. Context 사용을 위한 커스텀 Hook
export const useRightSideBar = () => {
    const context = useContext(RightSideBarContext);
    
    if (!context) {
        throw new Error('useRightSideBar must be used within RightSideBarProvider');
    }
    
    return context;
};

// 3. Provider 컴포넌트
export const RightSideBarProvider = ({ children }) => {
    // 상태 정의
    const [isOpenRightSideBar, setIsOpenRightSideBar] = useState(false);
    const [rightContent, setRightContent] = useState(null); // 오른쪽 사이드바에 표시 할 React 컴포넌트
    const [rightWidth, setRightWidth] = useState('680px');

    // 메서드 정의
    const openRightSideBarWithContent = (content, width = '680px') => {
        setRightWidth(width);
        setRightContent(content);
        setIsOpenRightSideBar(true);
    };

    const closeRightSideBar = () => {
        setRightWidth('680px');
        setRightContent(null);
        setIsOpenRightSideBar(false);
    };

    // Context 값 정의
    const value = {
        isOpenRightSideBar,
        rightContent,
        rightWidth,
        openRightSideBarWithContent,
        closeRightSideBar
    };

    return (
        <RightSideBarContext.Provider value={value}>
            {children}
        </RightSideBarContext.Provider>
    );
};
